module.exports = __webpack_public_path__ + "static/media/05.8ad2d5a0.png";